import App from './App';

export default App;



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/containers/App/index.js